<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Información del cliente</h5>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <tbody>
          <tr>
            <td><strong>Nombre completo</strong></td>
            <td>{{ cliente.descripcion }}</td>
            <td><strong>Tipo de identificación</strong></td>
            <td>{{ cliente.descripcion_tipo_identificacion }}</td>
          </tr>
          <tr>
            <td><strong>Número de identificación</strong></td>
            <td>{{ cliente.numero_identificacion }}</td>
            <td><strong>Dirección</strong></td>

            <td>
              <button
                v-if="cliente.coordenadas_cliente != null"
                @dblclick="verDireccionCliente"
                type="button"
                class="btn-info btn--text"
              >
                {{ cliente.direccion }}
              </button>
              <span v-else>
                {{ cliente.direccion }}
              </span>
            </td>
          </tr>

          <tr>
            <td><strong>Teléfono(s)</strong></td>
            <td>{{ cliente.telefonos }}</td>
            <td><strong>Celular(es)</strong></td>
            <td>{{ cliente.celulares }}</td>
          </tr>
          <tr>
            <td><strong>Correo(s)</strong></td>
            <td>{{ cliente.correos_electronicos }}</td>
            <td><strong>Referencia de domicilio</strong></td>
            <td>{{ cliente.referencia_domicilio }}</td>
          </tr>
          <tr>
            <td>
              <strong>Observación de cliente</strong>
            </td>
            <td colspan="3">
              {{ cliente.observacion_cliente }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
      <button
        type="button"
        @click="$emit('cerrar')"
        class="btn-danger btn--text"
      >
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      cliente: this.value,
    };
  },
  methods: {
    verDireccionCliente: function () {
      window.open(
        "https://maps.google.com?q=" +
          this.cliente.coordenadas_cliente.coordinates[1] +
          "," +
          this.cliente.coordenadas_cliente.coordinates[0],
        "_blank"
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/InformacionCliente.vue